import { jsx as o } from "react/jsx-runtime";
const i = {
  Up: 90,
  Right: 180,
  Down: 270,
  Left: 0
}, a = ({
  width: r = 16,
  height: t = 16,
  color: e = "var(--color-grayScale)",
  rotate: n = "Right"
}) => /* @__PURE__ */ o(
  "svg",
  {
    style: {
      transform: `rotate(${i[n]}deg)`
    },
    width: r,
    height: t,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "data-testid": "arrow-icon",
    children: /* @__PURE__ */ o(
      "path",
      {
        d: "M9 4L5 8L9 12",
        stroke: e,
        strokeWidth: "1.5",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }
    )
  }
);
export {
  a as ArrowIcon
};
